import { ApiRequest } from '../../api/request';

export class RequestFieldsService extends ApiRequest {
  constructor($http, $q, appConfig) {
    'ngInject';
    super({ $http, $q, appConfig });
  }

  all(params) {
    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/requests/_fields`,
      params,
    });
  }
}

export class OutgoingRequestFieldsService extends ApiRequest {
  constructor($http, $q, appConfig) {
    'ngInject';
    super({ $http, $q, appConfig });
  }

  all() {
    return this.$http({
      method: 'GET',
      url: `${this.api}/aid/requests/_fields/outgoing`,
    });
  }
}
